<template>
  <v-container class="px-0 my-0 pt-0 my-lg-3">
    <v-row class="mt-0 mt-lg-3">
      <v-col class="v-col-12 px-5 px-lg-0 v-col-lg-12">
        <div class="w-100 bg-lg-white pa-2 pa-lg-5">
          <v-breadcrumbs class="pa-0 d-none d-lg-block">
            <v-breadcrumbs-item class="text-color-0">Home</v-breadcrumbs-item>
            <v-breadcrumbs-divider><v-icon icon="mdi-chevron-right text-color-1"></v-icon></v-breadcrumbs-divider>
            <v-breadcrumbs-item class="text-color-0">Busca</v-breadcrumbs-item>
          </v-breadcrumbs>
          <v-row class="mt-0 mt-lg-3 d-none d-lg-flex">
            <v-col class="d-flex">
              <v-skeleton-loader :loading="loadingProducts" type="text" width="120px" class="ma-0">
                <b class="text-color-0">{{ getCount }} {{ getCount == 1 ? 'produto':'produtos'}}</b>
              </v-skeleton-loader>
            </v-col>
            <v-col class="d-flex justify-end">
              <v-btn flat variant="text" @click="ordenar(0)" class="br-10" :class="order == 0 ? 'text-color-1': 'text-color-0'">
                A-Z
              </v-btn>
              <v-btn flat variant="text" @click="ordenar(1)" class="br-10 ms-1" :class="order == 1 ? 'text-color-1': 'text-color-0'">
                Z-A
              </v-btn>
              <v-btn flat variant="text" @click="ordenar(2)" class="br-10 ms-1" :class="order == 2 ? 'text-color-1': 'text-color-0'">
                Maior preço
              </v-btn>
              <v-btn flat variant="text" @click="ordenar(3)" class="br-10 ms-1" :class="order == 3 ? 'text-color-1': 'text-color-0'">
                Menor preço
              </v-btn>
            </v-col>
          </v-row>
          <div v-if="loadingProducts">
            <v-row class="mt-0 mt-lg-3">
              <v-col v-for="a in 4" :key="a" class="v-col-12 pa-0 pa-lg-7 v-col-xl-3 d-flex justify-center v-col-lg-3">
                <v-skeleton-loader type="image" width="100%" height="400px"></v-skeleton-loader>
              </v-col>
            </v-row>
          </div>
          <div v-else>
            <v-row v-if="find_by	 != ''" class="my-6">
              <v-col class="v-col-12 pa-0 pa-lg-2 d-flex">
              <span class="text-color-0 text-large">Você quis dizer <b>{{ find_by	 }}</b>?</span>
              </v-col>
            </v-row>
            <v-row v-if="getProdutosFeedOrdered().length > 0" class="mt-0 mt-lg-3">
              <v-col v-for="p in getProdutosFeedOrdered(order)" :key="p.isu" class="v-col-12 pa-0 pa-lg-2 v-col-lg-3 v-col-xl-2 d-flex justify-center v-col-lg-3">
                <Product :product="p"></Product>
              </v-col>
            </v-row>
            <v-row v-else class="my-6">
              <v-col class="v-col-12 pa-0 pa-lg-2 d-flex justify-center">
              <span class="text-color-1">Nenhum produto encontrado.</span>
              </v-col>
            </v-row>
          </div>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import Product from '@/components/Product.vue';
import { capitalize } from '@/store/services/utils.js';
export default {
  name: "Busca de Produtos",
  components: {
    Product
  },
  data(){
    return {
      texto: '',
      order: null,
      find_by: ""
    }
  },
  computed: {
    ...mapGetters('products', {
      getProdutosFeedOrdered: 'getProdutosFeedOrdered',
      getCount: 'getCount'
    }),
    ...mapState('products', {
      loadingProducts: 'loadingProducts'
    }),
  },
  methods: {
    ...mapActions('main', {
      setConfig: 'setConfig',
    }),
    ...mapActions('products', {
      buscaProdutos: 'buscaProdutos'
    }),
    capitalize,
    Nav(){
      this.texto = this.$route['params']['texto'];
      this.buscaProdutos({ "name": this.texto }).then(function(retorno){
        this.find_by = retorno;
      }.bind(this));
    },
    ordenar(i){
      this.order = i;

    }
  },
  mounted() {
    this.setConfig().then(function(retorno){
      if(retorno){
        this.Nav();
      } else {
        this.emitter.emit('dialogStores');
      }
      this.emitter.emit("sendAnalyticsView", { screen_name: this.$options.name } );
    }.bind(this))
    .catch(function () {
      this.$router.push("/baixeoapp");
    }.bind(this));
  },
}
</script>